// src/components/dashboard/utils/ConfirmDialog.js
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./css/ConfirmDialog.css"; // <-- import your attached CSS

export default function ConfirmDialog({
                                          open,
                                          title = "Are you sure?",
                                          message = "",
                                          confirmText = "Yes",
                                          cancelText = "Cancel",
                                          onConfirm,
                                          onCancel,
                                      }) {
    // hooks must be called unconditionally
    useEffect(() => {
        if (!open) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        const onKey = (e) => {
            if (e.key === "Escape") onCancel?.();
            if (e.key === "Enter") onConfirm?.();
        };
        window.addEventListener("keydown", onKey);

        return () => {
            document.body.style.overflow = prev;
            window.removeEventListener("keydown", onKey);
        };
    }, [open, onCancel, onConfirm]);

    if (!open) return null;

    return createPortal(
        <div className="confirm-modal" role="dialog" aria-modal="true" aria-label="Confirm">
            <div className="confirm-backdrop" onClick={onCancel} />
            <div className="confirm-card" onClick={(e) => e.stopPropagation()}>
                <div className="confirm-header">
                    <h3>{title}</h3>
                    <button className="confirm-close" onClick={onCancel} aria-label="Close">×</button>
                </div>

                <div className="confirm-body">{message}</div>

                <div className="confirm-actions">
                    <button className="btn-secondary" onClick={onCancel}>{cancelText}</button>
                    <button className="btn-primary" onClick={onConfirm}>{confirmText}</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
